<mat-dialog-content>
  <div [ngSwitch]="popupCustomProps.content">
    <p *ngSwitchCase="PopupContentType.SMTH_WENT_WRONG">
      Something went wrong ...
    </p>
    <p *ngSwitchCase="PopupContentType.INTERNET_CONNECTION_ISSUES">
      Your log out request could not be completed. Please check your internet connection and try again.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-flat-button (click)="onOkClick()">Ok</button>
</mat-dialog-actions>
